<p-card>
  <ng-template pTemplate="header">
    <div class="px-3 pt-3">
      <h3 class="m-0">{{title}}</h3>
    </div>
  </ng-template>

  <form [formGroup]="searchForm" class="flex align-items-end gap-3">
    <!-- Institution -->
    <div class="flex-1">
      <label for="country" class="block mb-2">Pays</label>
      <p-select
        id="country"
        formControlName="country"
        [options]="countries"
        optionLabel="country"
        optionValue="country"
        placeholder="Sélectionner un pays"
        [filter]="true"
        [showClear]="true"
        (onChange)="countriesDropdownChange($event)"
        (onClear)="resetNameDropDown()"
        styleClass="w-full">

        <ng-template let-bank pTemplate="item">
          <div class="flex align-items-center gap-2">
            <img alt="{{ bank.country }}"
                  src="https://purecatamphetamine.github.io/country-flag-icons/3x2/{{ bank.country | uppercase }}.svg"
                  style="width: 18px" />
            <div>{{ bank.country }}</div>
          </div>
        </ng-template>
      </p-select>
    </div>

    <!-- Compte -->
    <div class="flex-1">
      <label for="name" class="block mb-2">Nom</label>
      <p-select
        id="name"
        formControlName="name"
        [options]="dataCopy"
        optionLabel="name"
        optionValue="name"
        placeholder="Sélectionner un nom"
        [filter]="true"
        [showClear]="true"
        styleClass="w-full">
      </p-select>
    </div>

    <!-- Boutons d'action -->
    <div class="flex gap-2">
      <p-button
        icon="pi pi-refresh"
        severity="secondary"
        [rounded]="true"
        pTooltip="Réinitialiser"
        tooltipPosition="top"
        (onClick)="onReset()">
      </p-button>
      <p-button
        icon="pi pi-search"
        severity="primary"
        [rounded]="true"
        pTooltip="Rechercher"
        tooltipPosition="top"
        (onClick)="onSearch()">
      </p-button>
    </div>
  </form>
</p-card>
